// extracted by mini-css-extract-plugin
export default {"floatAd":"index_floatAd_1GSlU"};